import React, {ReactElement} from 'react';
import {EventKind} from 'services/analytics';
import {compose} from 'shared/utils/compose';
import {enterSymbol} from 'ui/keyboard';
import {useDispatch} from 'ui/store';
import {useUIStore, hideKeyboard as hideKeyboardAction} from 'store/UI';
import {AppendRecord, AdapteeProps as AppendRecordProps} from 'ui/adapters/Core';
import {useAnalytics} from 'ui/adapters/Analytics';
import {Key} from 'components/Key';
import {useIsRefillEnabled, setRefillEnabled} from 'store/CoreSettings';

export const Enter = (): ReactElement => {
  const {settingsVisible} = useUIStore();
  const hideKeyboard = useDispatch(hideKeyboardAction);
  const registerEvent = useAnalytics(EventKind.AddSpend);
  const isRefillEnabled = useIsRefillEnabled();
  const toggleRefillEnabled = useDispatch(setRefillEnabled, !isRefillEnabled);

  return (
    <AppendRecord>
      {({addRecord}: AppendRecordProps) => {
        const addAndRegisterSpend = compose(addRecord, registerEvent);
        const handlePress = settingsVisible ? hideKeyboard : addAndRegisterSpend;
        return (
          <Key
            symbol={enterSymbol}
            onPress={handlePress}
            onLongPress={toggleRefillEnabled}
            delayMS={5000}
          />
        );
      }}
    </AppendRecord>
  );
};
